<template>
    <div class="page-wrapper">
        <div class="page-header">
            <WidgetToolbar title="Calendar" :icon="require('@/assets/admin-icon/menu/calendar-active.svg')">
                <div class="options">
                    <DropdownButton class="green" @onSubmit="addNew($event, 'selected')" :content="[
                        { name: 'Meritios Event', value: 'meritios' },
                        { name: 'Google Event', value: 'google' },
                        { name: 'Microsoft Event', value: 'microsoft' },
                    ]">
                        Add Event +
                    </DropdownButton>
                    <div class="h-spacer"></div>
                    <DropdownButton class="blue" @onSubmit="connectCalendar($event, 'selected')" :content="[
                        { name: 'Google Calendar', value: 'google' },
                        { name: 'Microsoft Calendar', value: 'microsoft' },
                    ]">
                        Connect Calendar +
                    </DropdownButton>
                </div>
            </WidgetToolbar>
        </div>
        <div class="page-tab-container">
            <div class="page-calendar-filter">
                <div class="calendar-left-filter row">
                    <widgetSearch class="search-account" placeholder="Search here..." icon="right">
                    </widgetSearch>
                    <div class="v-line-divider" style="height: 40px"></div>
                    <widgetDropdown v-model="showViewFilter" class="option-item" :right="true" :hover="false"
                        :interactive="true">
                        <button class="btn-dropdown">
                            <span v-if="selectedViewLabel">{{ selectedViewLabel }}</span>
                            <span v-else>Change view</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in viewFilterOptions"
                                @click="onChangeCalendarView(item)">
                                {{ item.label }}
                            </a>
                        </div>
                    </widgetDropdown>
                </div>
                <div class="calendar-right-filter row">
                    <div class="filter-label">
                        <span>Filter:</span>
                    </div>
                    <widgetDropdown v-model="showEventFilter" class="option-item" style="width:145px" :right="true"
                        :hover="false" :interactive="true">
                        <button class="btn-dropdown">
                            <span v-if="selectedEventLabel">{{ selectedEventLabel }}</span>
                            <span v-else>Event Type</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in eventFilterOptions"
                                @click="onChangeCalendarEvent(item)">
                                {{ item.label }}
                            </a>
                        </div>
                    </widgetDropdown>
                    <div class="v-line-divider" style="height: 40px"></div>
                    <widgetDateRangePicker left_input_placeholder="From" right_input_placeholder="To"
                        :left_input_disabled="false" :right_input_disabled="false" :left_input_disabled_dates="{}"
                        :right_input_disabled_dates="{}"></widgetDateRangePicker>
                </div>
            </div>
            <div class="page-calendar-widget">
                <FullCalendar class="calendar-widget" :options='calendarOptions' ref="fullCalendar">
                    <template v-slot:eventContent='arg'>
                        <div class="calendar-event">
                            <div class="calendar-event-type"
                                :style="{ backgroundColor: arg.event.extendedProps.bgColor, color: arg.event.extendedProps.txtColor }">
                                {{ arg.event.extendedProps.label }}
                            </div>
                            <div class="calendar-event-content">
                                <b class="calendar-event-time">{{ arg.timeText }}</b>
                                <i class="calendar-event-title">{{ arg.event.title }}</i>
                            </div>
                        </div>
                    </template>
                </FullCalendar>
            </div>
        </div>

        <add-event-modal v-if="showAddEventModal" :type="platform_event_type"
            @success="showAddEventModal = false, getCalendarEvents()"
            @close="showAddEventModal = false"></add-event-modal>

    </div>
</template>
<script>
import { eventBus } from "@/main";
import FullCalendar from '@fullcalendar/vue'
import monthGridPlugin from "@fullcalendar/multimonth";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from '@fullcalendar/interaction'
import addEventModal from "./models/addEventModal.vue";
export default {
    components: {
        FullCalendar,
        addEventModal
    },
    data: function () {
        return {
            calendarOptions: {
                plugins: [monthGridPlugin, dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
                initialView: 'dayGridMonth',
                events: [],
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                eventAdd: this.handleEventAdd,
                eventChange: this.handleEventChange,
                eventRemove: this.handleEventRemove,
            },
            filterForm: {
                event_type: 'tasks',
            },
            // ============ View ============
            selectedView: 'dayGridMonth',
            showViewFilter: false,
            viewFilterOptions: [
                { label: 'Year View', value: 'multiMonthYear' },
                { label: 'Month View', value: 'dayGridMonth' },
                { label: 'Week View', value: 'dayGridWeek' },
                { label: 'Day View', value: 'timeGridDay' },
            ],
            // ============ Filter ============
            selectedEvent: '',
            showEventFilter: false,
            eventFilterOptions: [
                { label: 'All', value: 'all' },
                { label: 'Tasks', value: 'tasks' },
                { label: 'Google Event', value: 'google' },
                { label: 'Microsoft Event', value: 'microsoft' },
                // { label: 'Lia', value: 'lia' },
            ],
            showAddEventModal: false,
            platform_event_type: '',
        };
    },
    mounted() {
        let vm = this;
        let platform = vm.$route.query.platform;
        if (platform == 'google') {
            vm.$notify({
                group: 'status',
                title: 'Info',
                text: 'Google Calendar connected',
                type: 'info',
                duration: 3000,
            });
        }
        vm.getCalendarEvents();

    },
    computed: {
        selectedViewLabel() {
            let vm = this;
            return vm.selectedView ? vm.viewFilterOptions.find((item) => item.value === vm.selectedView).label : null;
        },
        selectedEventLabel() {
            let vm = this;
            return vm.selectedEvent ? vm.eventFilterOptions.find((item) => item.value === vm.selectedEvent).label : null;
        }
    },
    methods: {
        handleDateSelect(info) {
            let vm = this;
            console.log(info);
        },
        handleEventClick(info) {
            let vm = this;
            console.log("event:", info);
            if (info.event.extendedProps.type == 'google') {
                if (info.event.extendedProps.meetLink) {
                    window.open(info.event.extendedProps.meetLink, "_blank");
                }
            }
        },
        handleEventAdd(info) {
            let vm = this;
            console.log(info);
        },
        handleEventChange(info) {
            let vm = this;
            console.log(info);
        },
        handleEventRemove(info) {
            let vm = this;
            console.log(info);
        },
        addNew(type) {
            let vm = this;
            vm.platform_event_type = type;
            vm.showAddEventModal = true;
        },
        connectCalendar(type) {
            let vm = this;
            if (type == 'google') {
                vm.signInBySocial('google');
            } else if (type == 'microsoft') {
                vm.signInBySocial('microsoft');
            }
        },
        signInBySocial(sign_type) {
            let vm = this;
            if (sign_type == "linkedin") {
                this.$store
                    .dispatch("AUTH_LINKEDIN_SIGNUP_REQUEST", {})
                    .then((responce) => {
                        vm.loading = false;
                    });
            } else if (sign_type == "google") {
                this.$store
                    .dispatch("AUTH_GOOGLE_SIGNUP_REQUEST", {
                        data: {
                            browser_path: "/crm?path=/calendar?platform=google",
                            task: "list_events",
                            consultified_token: vm.$getLoggedUser().consultified_token,
                        },
                        canRedirect: false,

                    })
                    .then((responce) => {
                        console.log(responce);
                        vm.loading = false;
                        const authUrl = responce.data.url;
                        // open in new tab
                        window.open(authUrl, "_blank");
                    });
            } else if (sign_type == "facebook") {
                this.$store
                    .dispatch("AUTH_FACEBOOK_SIGNUP_REQUEST", {})
                    .then((responce) => {
                        vm.loading = false;
                    });
            } else if (sign_type == "microsoft") {
                this.$store
                    .dispatch("AUTH_MICROSOFT_SIGNUP_REQUEST", {})
                    .then((responce) => {
                        vm.loading = false;
                    });
            }
        },
        onChangeCalendarView(item) {
            let vm = this;
            vm.showViewFilter = false;
            vm.selectedView = item.value;
            let calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.changeView(item.value)
        },
        getCalendarEvents() {
            let vm = this;
            vm.$store
                .dispatch("CALENDAR_GET_EVENTS", vm.filterForm)
                .then((response) => {
                    vm.calendarOptions.events = response.data.map((item) => {
                        if (item.type == 'tasks') {
                            return {
                                title: item.data.name,
                                start: new Date(item.start),
                                extendedProps: {
                                    label: 'Task',
                                    type: 'tasks',
                                    bgColor: '#0884AF2E',
                                    txtColor: '#0884AF'
                                }
                            };
                        } else if (item.type == 'leads') {
                            return {
                                title: item.data.name,
                                start: new Date(item.start),
                                extendedProps: {
                                    label: 'Lead',
                                    type: 'leads',
                                    bgColor: '#FF961B1A',
                                    txtColor: '#FF961B'
                                }
                            };
                        } else if (item.type == 'google') {
                            return {
                                title: item.data.summary,
                                start: new Date(item.data.start.date ? item.data.start.date : item.data.start.dateTime),
                                extendedProps: {
                                    label: 'Google Event',
                                    type: 'google',
                                    meetLink: item.data.hangoutLink,
                                    bgColor: '#FF961B1A',
                                    txtColor: '#FF961B'
                                }
                            };
                        }
                        else {
                            return null
                        }

                    }).filter((item) => item !== null);

                })
                .catch((error) => {

                });
        },
        onChangeCalendarEvent(item) {
            let vm = this;
            vm.showEventFilter = false;
            vm.selectedEvent = item.value;
            vm.filterForm.event_type = item.value;
            vm.getCalendarEvents();
        }
    },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #ebebeb;
    padding: 5px;

    .page-header {
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        .options {
            display: flex;
            align-items: center;

            .search-account {
                width: 250px;
            }

            .btn-add {
                margin-left: 20px;
            }
        }
    }

    .page-tab-container {
        display: flex;
        flex-direction: column;
        height: calc(100% - 55px);
        background: #fff;
        border-radius: 5px;
        padding: 10px;

        .page-calendar-filter {
            height: 50px;
            background-color: #fff;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .option-item {
                border: 1px solid #ddd;
                height: 30px;
                padding: 0px 7px;
                display: flex;
                align-items: center;
                border-radius: 4px;
            }

            .calendar-right-filter {
                .filter-label {
                    margin-right: 10px;
                }
            }
        }

        .page-calendar-widget {
            height: calc(100% - 58px);
            background-color: #fff;
            border-radius: 5px;
            padding: 10px;
            overflow-y: auto;

            .calendar-widget {
                height: 100%;
                display: flex;
                flex-direction: column;

                .calendar-event {
                    display: flex;
                    flex-direction: column;
                    padding: 5px;
                    border-radius: 5px;
                    background-color: #f5f5f5;
                    margin-bottom: 5px;

                    .calendar-event-type {
                        padding: 5px 10px;
                        border-radius: 5px;
                        margin-bottom: 8px;

                        &.tasks {
                            background-color: #0884AF2E;
                            color: #0884AF;
                        }
                    }

                    .calendar-event-content {
                        display: flex;
                        align-items: center;

                        .calendar-event-time {
                            margin-right: 10px;
                        }

                        .calendar-event-title {
                            font-style: italic;
                        }
                    }


                }
            }
        }
    }

}

.vdp-datepicker__calendar {
    right: 0px;
}
</style>

<style lang="scss">
.page-calendar-filter {
    .vdp-datepicker__calendar {
        right: 0px;
    }
}

.page-calendar-widget {
    .fc {
        .fc-daygrid-day.fc-day-today {
            background-color: #ffffff !important;

            .fc-daygrid-day-top {
                .fc-daygrid-day-number {
                    background: #1ba5a4;
                    color: #fff;
                    border-radius: 50%;
                    height: 34px;
                    width: 34px;
                    margin: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }

        .fc-col-header-cell.fc-day.fc-day-today {
            background: #1ba5a4 !important;

            a {
                color: #fff;
            }
        }

        .fc-daygrid-day-frame {
            min-height: 100px;
            position: relative;
        }
    }
}
</style>